import React from 'react';

import styled from 'styled-components'
import { darken } from 'polished'
import { colors, fonts, padding, pattern, transition } from '../styles'

const Button = (props) => {

    const {
        className,
        link,
        text
    } = props;

    return (
        <a className={`button ${className}`} 
            href={link} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <span>
                {text}
            </span>
        </a>
    )
}

const StyledButton = styled(Button)`
    display: block;
    position: relative;
    margin: .5em auto;
    text-align: center;

    span {
        border-radius: .5rem;
        display: block;
        ${fonts.lato()}
        font-size: 1.125rem;
        line-height: 1.4em;
        ${pattern()}
        padding: calc(.5 * ${padding}) ${padding};
        color: ${props => darken(.15, colors[props.color])};
        position: relative;
        z-index: 2;
        transition: ${transition};
        transform: translateY(-.25em);
    }

    &:after {
        content: '';
        display: block;
        position: absolute;
        border-radius: .5rem;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        background: ${props => darken(.15, colors[props.color])};
    }

    &:hover {
        span {
            transform: translateY(-.375em);
        }
    }

    &:active {
        span {
            transform: translateY(0);
        }
    }
`

export default StyledButton;